import React, { useEffect } from "react";
import { Col, Flex, Row } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { sanitizeDataTypeClientSide } from "../../../../../utils/utils";
import { userRoles } from "../../../../../constants/userRolesConts";
import { sendPushNotificationAction } from "../../../../../redux/services/notify/notifyServices";
import {
  getCityAction,
  getCountryAction,
  getStateAction,
} from "../../../../../redux/services/auth/authServices";
import {
  cleanupCityList,
  cleanupStateList,
} from "../../../../../redux/reducers/authReducer";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";

const Notify = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader] = useState(false);
  /* loading dependencies */

  /* select list dependencies */
  const { countryList, stateList, cityList } = useSelector(
    (state) => state?.auth
  );
  const [isCountrySelected, setIsCountrySelected] = useState(false);
  const [isStateSelected, setIsStateSelected] = useState(false);
  const [selectedCountryObj, setSelectedCountryObj] = useState(null);
  const [selectedStateObj, setSelectedStateObj] = useState(null);
  const [selectedCityObj, setSelectedCityObj] = useState(null);
  const [selectedCountries, setSelectedCountries] = useState([]);
  /* select list dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const initialValues = {
    user_role: null,
    title: "",
    message: "",
    title_ar: "",
    message_ar: "",
    country: [],
    state: null,
    city: null,
  };
  /* form dependencies */

  const selectListApiCalls = () => {
    // Country select list
    dispatch(getCountryAction());
  };

  useEffect(() => {
    /* initial dependencies - Edit */
    /* initial dependencies - Edit */
    /* initial dependencies - Add */
    /* initial dependencies - Add */
    selectListApiCalls(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* on Country changed */
  const onCountryChanged = (value) => {
    if (value.length === 1) {
      const selectedCountryObject = countryList?.find(
        (item) => item._id === value[0]
      );
      setSelectedCountryObj(selectedCountryObject);
      if (selectedCountryObject) {
        let stateObject = {
          country_code: selectedCountryObject?.numeric_code,
        };
        dispatch(getStateAction(stateObject));
        dispatch(cleanupStateList());
        dispatch(cleanupCityList());
        setIsCountrySelected(true);
        setSelectedCountries([]);
      }
      form.resetFields(["state", "city"]);
    } else {
      dispatch(cleanupStateList());
      dispatch(cleanupCityList());
      setIsCountrySelected(false);
      setSelectedCountries(value);
      form.resetFields(["state", "city"]);
    }
  };
  /* on Country changed */

  /* on State changed */
  const onStateChanged = (value) => {
    const selectedStateObject = stateList?.find((item) => item.id === value);
    setSelectedStateObj(selectedStateObject);
    if (selectedStateObject) {
      let dataToBeSent = {
        stateCode: selectedStateObject?.id,
      };
      dispatch(getCityAction(dataToBeSent));
      dispatch(cleanupCityList());
      setIsStateSelected(true);
      form.resetFields(["city"]);
    }
    else {
      setIsStateSelected(false);
      form.resetFields(["city"]);
    }
  };
  /* on State changed */

  /* on City changed */
  const onCityChanged = (value, element) => {
    const selectedCityObject = cityList?.find(
      (item) => item.id === element?.value
    );
    setSelectedCityObj(selectedCityObject);
  };
  /* on City changed */

  /* reset default form fields */
  const resetDefaultFields = () => {
    form.setFieldsValue({ ...initialValues });
    setSelectedCountryObj(null);
    setSelectedStateObj(null);
    setSelectedCityObj(null);
    setSelectedCountries([]);
    dispatch(cleanupStateList());
    dispatch(cleanupCityList());
    setIsCountrySelected(false);
    setIsStateSelected(false)
  };
  /* reset default form fields */

  /* Form submit handler */
  const onSubmit = (values) => {
    const dataToBeSent = {
      ...values,
      country:
        selectedCountries.length > 1
          ? selectedCountries
          : selectedCountryObj?._id || "",
      state: selectedStateObj?.name || "",
      city: selectedCityObj?.name || "",
    };

    dispatch(
      sendPushNotificationAction(dataToBeSent, navigate, setLoading)
    ).then(() => {
      resetDefaultFields();
    });
  };
  /* Form submit handler */

  return (
    <div className="servicesListContainer">
      <Flex vertical gap="2rem">
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          <Row gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item
                name="user_role"
                label={
                  <RequiredLabel
                    text={t("Modules.Configuration.userType")}
                    required={true}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: t("Modules.Configuration.pleaseSelectUserType"),
                  },
                ]}
              >
                <Select
                  loading={selectListLoader}
                  options={[
                    {
                      value: userRoles.SERVICE_PROVIDER_ADMIN,
                      label: "Service Provider",
                    },
                    { value: userRoles.CUSTOMER, label: "User" },
                  ]}
                  placeholder={t("Modules.Configuration.selectUserType")}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("ProfileSetup.countryLabel")}
                    required={false}
                  />
                }
                name="country"
              >
                <Select
                  mode="multiple"
                  placeholder={t("ProfileSetup.countryPlaceholder")}
                  popupMatchSelectWidth={true}
                  onChange={(value, element) => {
                    onCountryChanged(value, element);
                  }}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {countryList &&
                    countryList?.map((item) => (
                      <Select.Option key={item?._id} value={item?._id}>
                        {item?.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("ProfileSetup.stateProviceLabel")}
                    required={false}
                  />
                }
                name="state"
              >
                <Select
                  placeholder={t("ProfileSetup.stateProvicePlaceholder")}
                  popupMatchSelectWidth={true}
                  onChange={(value, element) => {
                    onStateChanged(value, element);
                  }}
                  disabled={!isCountrySelected}
                  showSearch
                  filterOption={(input, option) => {
                    return (option?.children ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  }
                >
                  {stateList?.map((item) => (
                    <Select.Option key={item?.id} value={item?.id}>
                      {item?.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("ProfileSetup.cityLabel")}
                    required={false}
                  />
                }
                name="city"
              >
                <Select
                  placeholder={t("ProfileSetup.cityPlaceholder")}
                  onChange={(value, element) => {
                    onCityChanged(value, element);
                  }}
                  popupMatchSelectWidth={true}
                  disabled={!isStateSelected}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.children ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {cityList?.map((item) => (
                    <Select.Option key={item?.id} value={item?.id}>
                      {item?.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("Modules.Notify.title")}
                    required={true}
                  />
                }
                name="title"
                rules={[
                  {
                    required: true,
                    message: t("Modules.Notify.pleaseEnterTitle"),
                  },
                  {
                    whitespace: true,
                    message: t("Modules.Notify.pleaseEnterTitle"),
                  },
                ]}
                normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <Input placeholder={t("Modules.Notify.enterTitle")} />
              </Form.Item>
            </Col>
            <Col span={8}>
            <Form.Item
                    label={
                      <RequiredLabel
                        text={`${t("Modules.Notify.title")} ${t("CommonUtils.inArabic")}`}
                        required={true}
                      />
                    }
                    name="title_ar"
                    rules={[
                      {
                        required: true,
                        message: `${t("Modules.Notify.pleaseEnterTitle")} ${t("CommonUtils.inArabic")}`,
                      },
                      {
                        whitespace: true,
                        message: `${t("Modules.Notify.pleaseEnterTitle")} ${t("CommonUtils.inArabic")}`,
                      },
                    ]}
                    normalize={(value) => sanitizeDataTypeClientSide(value)}
                  >
                    <Input
                      dir="rtl"
                      placeholder={`${t("Modules.Notify.enterTitle")} ${t("CommonUtils.inArabic")}`}
                    />
                  </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("Modules.Notify.description")}
                    required={true}
                  />
                }
                name="message"
                rules={[
                  {
                    required: true,
                    message: t("Modules.Notify.pleaseEnterDescription"),
                  },
                  {
                    whitespace: true,
                    message: t("Modules.Notify.pleaseEnterDescription"),
                  },
                ]}
                // normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <TextArea
                  rows={4}
                  showCount
                  maxLength={
                    appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA
                  }
                  placeholder={t(
                    "CommonUtils.enterDescriptionUpto255Characters"
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
            <Form.Item
                    label={
                      <RequiredLabel
                        text={
                          `${t("Modules.Services.ServicesForm.description")} ${t("CommonUtils.inArabic")}`
                        }
                        required={true}
                      />
                    }
                    name="message_ar"
                    // normalize={(value) => sanitizeDataTypeClientSide(value)}
                    rules={[
                      {
                        required: true,
                        message: `${t(
                          "Modules.Services.ServicesForm.pleaseEnterDescription"
                        )} ${t("CommonUtils.inArabic")}`,
                      },
                      {
                        whitespace: true,
                        message: `${t(
                          "Modules.Services.ServicesForm.pleaseEnterDescription"
                        )} ${t("CommonUtils.inArabic")}`,
                      },
                    ]}
                  >
                    <TextArea
                      dir="rtl"
                      rows={4}
                      showCount
                      maxLength={
                        appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA
                      }
                      placeholder={`${t(
                        "CommonUtils.enterDescriptionUpto255Characters"
                      )} ${t("CommonUtils.inArabic")}`}
                    />
                  </Form.Item>
            </Col>
            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("CommonUtils.submit")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Flex>
    </div>
  );
};

export default Notify;
